export default {
    notGuests (state) {
        return state.users.filter(user => user.is_guest === false)
    },

    guests (state) {
        return state.users.filter(user => user.is_guest === true)
    },

    sortedUsers (state, getters) {
        return getters.notGuests.concat(getters.guests)
    }
}
